import { EDrivers } from '@enums/api.enum';

import client from '../apiClient';

export type Supplier = {
	id: number;
	label: string;
};

export type DriverParam = {
	id: number;
};

export type SupplierResponse = {
	list: Supplier[];
};

const endpoint = EDrivers.endpoint;

const getSingle = <T>({ id }: DriverParam) => client.get<T>(`${endpoint}${EDrivers.single}${id}`);

const getSuppliers = <T>() => client.get<T>(EDrivers.suppliers);

export default {
	getSingle,
	getSuppliers,
};
